var _ellipse, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.99935,
    cy: 8.33333,
    rx: 5.83333,
    ry: 5.83333,
    stroke: "#28475C",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 13.8018C4.90764 15.56 7.19451 16.6665 9.73981 16.6665C14.4862 16.6665 18.334 12.8188 18.334 8.07233C18.334 5.52702 17.2275 3.24016 15.4693 1.6665",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 3.79402C6.32164 4.25454 7.3262 5.5133 7.44324 6.86416C7.55264 8.12685 8.3563 9.15287 9.58398 9.16677C10.0558 9.17211 10.5329 8.81865 10.5317 8.32935C10.5314 8.17805 10.5073 8.02335 10.4696 7.88102C10.4172 7.68306 10.4125 7.45532 10.5215 7.22235C10.9027 6.40733 11.6524 6.18841 12.2464 5.74579C12.5099 5.54948 12.7502 5.34239 12.8562 5.17558C13.1488 4.71506 13.4414 3.79402 13.2951 3.3335",
    stroke: "#28475C",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.834 9.1665C15.651 9.68375 15.5215 11.0415 13.4552 11.0631C13.4552 11.0631 11.6254 11.0631 11.0765 12.0975C10.6373 12.9251 10.8935 13.8217 11.0765 14.1665",
    stroke: "#28475C",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3332V16.6665",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 18.3335H8.33398",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 18.3335H10",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobus);
export default __webpack_public_path__ + "static/media/Globus.39127a119c512ed9c1d30237d9b104e5.svg";
export { ForwardRef as ReactComponent };